const specConfig = {
    lineOverflow: 10,
    cornerLineLength: 80,
    innerMeasureMargin: 40,
    panLineMargin: 10,
    scale: 8,
    leftMargin: 80,
    topMargin: 100,
};

const optionsMap = {
    Center: 'C',
    Left: 'L',
    Right: 'R',
    Back: 'B',
    Round: 'P',
    Trench: 'RT',
    'Single Curb': 'SC',
    'Barrier Free': 'BF',
    'Polished Chrome': 'SQPC',
    'Brushed Nickel Solid Top': 'BN3',
    'Brushed Nickel': 'SQBN',
    'Oil Rubbed Bronze': 'OB',
    'Matte Black': 'MB',
    'Tileable Top': 'TBN',
};

const drainBaseSpec = {
    drainDepthExposed: 1.13,
    drainWidth: 4.69,
    drainInnerDiameter: 2.78,
    grateDepth: 3,
    grateThickness: 0.875,
};

const panBaseSpec = {
    curbWidth: 4.5,
    curbHeight: 4.5,
    height: 5.75,
    splashWallWidthInches: 0.50,
    plankFloorThickness: 1.33,
    trenchFloorThickness: 1.875,
    drainOpening: 5.50,
    drainTopDiameter: 2.5,
    drainPlateWidth: 4.25,
    drainDepthShroud: 0.63,
    floorPitch: 0.25,
};

const panManufacturingReq = {
    minPanWidth: 20,
    minPanDepth: 20,
    maxPanWidth: 120,
    maxPanDepth: 120,
    splashWallBuffer: 3,
    trenchWallBuffer: 2.5,
    trenchDrainBuffer: 2.5,
    drainTrenchEdgeBUffer: 2.25,
    measurementPercision: 0.25,
    minCurbWidth: 2,
    maxCurbWidth: 4.5,
    minCurbHeight: 3.5,
    maxCurbHeight: 4.5,
    standardCurb: 4.5,
};

const trenchGrateWidths = [
    57.5,
    49.5,
    40.5,
    31.5,
    22.5,
];
const whiteSpaceLength = 70;
const signatureWhiteSpace = (
    (amount) => (' '.repeat(amount))
)(whiteSpaceLength);
const specText = {
    companyName: 'TILE REDI',
    brandName: 'REDI YOUR WAY',
    approvalRequired: 'This is a DRAFT Spec. Once a P.O. is received the Official Engineering Spec will be created.',
    returnStatement: 'Production will proceed once the Official Engineering Spec is signed by Guest.',
    footerTitle: 'Customer Approval of DRAFT SPEC',
    agreementLine1: `I,${signatureWhiteSpace},${signatureWhiteSpace}, am the end user of this product`,
    agreementLine2: 'and hereby approve the creation of an Official Engineering Spec of shower pan to be manufactured by Tile Redi.',
    signaturePerson: 'Print Your Name',
    signatureCompany: 'Print Company Name or N/A',
    signature: 'Signature',
    date: 'Date',
    contactPhone: ' Toll Free:  800.232.6156\nTel:  954.323.0125\nFax:  954.344.8064',
    contactEmail: 'Email:  techsupport@tileredi.com',
    contactWebsite: 'Web:  TileRedi.com',
    sizeDisclaimer: 'All dimensions are within\ntolerances of -0.25″ to +0.0625″\nunless otherwise noted.',
    toleranceRange: '(+/-0.25)',
    deviceCompatibilityMessage: 'Rotate your device to continue',
};

const brandGrateMap = {
    'Redi Base': 'Round',
    'Wonder Drain': 'Round',
    'WonderFall Trench': 'Round',
    'Redi Trench': 'Trench',
};

const drainPositionMap = {
    'Right Drain': 'Right',
    'Side Drain': 'Right',
    'Left Drain': 'Left',
    'Back Drain': 'Back',
};
